import {Component, OnInit, Input, SimpleChanges, OnChanges, ChangeDetectorRef} from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Router, NavigationEnd, ActivatedRoute, NavigationExtras } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { PermissionsGuardService } from 'src/app/shared/services/permissions-guard.service';
import { NotificationIntervalService } from 'src/app/shared/services/notification.interval.service';
import { Subject, of, config } from 'rxjs';
import { LoginService } from 'src/app/auth/login/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CreateBookingService } from 'src/app/bookings/create-booking/create-booking.service';
import { FormControl, Validators } from '@angular/forms';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', '../../shared/styles/dropdown-option.scss']
})

export class HeaderComponent implements OnInit, OnChanges {

  bulkToggle = false;
  createToggle = true;

  checked = false;
  public additionalText: string;
  bookingCount$ = new Subject();
  vendorAcceptanceCount$ = new Subject();
  cabAllocCount$ = new Subject();
  notificationConfig;
  bookingIdForCreateBooking;
  bookingIdforVendor;
  bookingIdForCabAllocation;
  createBookingConfig: any;
  bulkBookingConfig: any;
  smallLogoURL: string;
  userRole: string;
  showCreateBookingButton: boolean;
  openPolicyPopup = false;
  cityList: any;
  city = new FormControl('', [Validators.required]);
  enableCompanyPolicy = false;
  policyData: any = {title: '', policy: '', };
  notificationCount = 0;
  @Input() createBookingList = [];
  @Input() vendorBookingList = [];
  @Input() cabAllocBookingList = [];
  @Input() headerTitle: string;

  constructor(public authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute,
              private commonService: CommonService, private commonBookingService: CommonBookingService,
              private permissionsGuardService: PermissionsGuardService,
              private notificationService: NotificationIntervalService,
              private loginService: LoginService, public changeDetect: ChangeDetectorRef,
              private createBookingService: CreateBookingService,
              private domSanitizer: DomSanitizer, ) {

  }
  ngOnInit(): void {
    this.notificationService.notificationConfigObs.subscribe((res) => {
      this.notificationConfig = res;
    });
    this.router.events.subscribe( (event) => {
      if (event instanceof NavigationEnd) {
        const urlItems = event.urlAfterRedirects.split('?');
        const urlRedirect = urlItems[0];
        switch (urlRedirect) {
          case '/bookings/edit':
            this.activatedRoute.queryParams.subscribe(params => {
              if (params.bookingId) {
                this.additionalText = `Booking Id: ${params.bookingId}`;
              }
            });
            break;
          default: this.additionalText = '';
        }
      }
    });
    this.commonService.roleConfig.subscribe((res: any) => {
      this.createBookingConfig = res.createBooking?.config.visibility.visible;
      this.bulkBookingConfig = res.bulkBooking?.config.visibility.visible;
      this.changeDetect.detectChanges();
      });

     // logo api
    this.commonService.getSmallLogo().subscribe(res => {
      const blob = new Blob([res.body], {type: 'jpeg'});
      const url = window.URL.createObjectURL(blob);
      this.smallLogoURL = url;
    });
    this.authService.getUserInfo().subscribe(res => this.userRole = res.employeeRoles[0]);
    this.city.valueChanges.pipe(distinctUntilChanged()).subscribe((res: any) => {
      if (res)
      {
        this.commonService.getPolicyData(res)
        .pipe(distinctUntilChanged()).subscribe(data => {
          if (data['title'] && data['policy']) {
            this.policyData = data;
          }
          else{
            this.policyData = {title: '', policy: '', };
          }
        });
      }
    });
    this.commonService.fetchConfig().subscribe(res => {
      // console.warn(res.pageConfigList[1].sectionConfigList[0].elementConfigList[5].config.values)
      const tripDetailsTabIndex = res.pageConfigList.findIndex((data: any[]) => data['elementKey'].toLowerCase() === 'trip details tab');
      const tripDetailsFormIndex = res.pageConfigList[tripDetailsTabIndex].sectionConfigList.findIndex((data: any[]) => data['elementKey'].toLowerCase() === 'trip details form');
      const cityIndex = res.pageConfigList[tripDetailsTabIndex].sectionConfigList[tripDetailsFormIndex].elementConfigList.findIndex((data: any[]) => data['elementKey'].toLowerCase() === 'city');
      // let tripDetailsTabIndex=res.pageConfigList.findIndex((data:any[])=>{return data['elementKey'].toLowerCase()==='trip details tab'})

      this.cityList = res.pageConfigList[tripDetailsTabIndex].sectionConfigList[tripDetailsFormIndex].elementConfigList[cityIndex].config.values;
    });

    this.commonService.fetchMiscConfig().subscribe(res => {
      this.enableCompanyPolicy = res.enableCompanyPolicy;
      if (this.enableCompanyPolicy){
        const companyPolicy = localStorage.getItem('companyPolicy');
        if (companyPolicy == 'true') {
        this.openPolicyPopup = false;
        }
        else{
          this.openPolicyPopup = true;
          this.commonService.getPolicyData('').subscribe(res => {
          });
        }
      }
    });



  }

  ngOnChanges(changes: SimpleChanges) {
    this.createBookingService.showCreateBookingButton.subscribe(res => this.showCreateBookingButton = res);
    if (changes.createBookingList && changes.createBookingList.currentValue) {
      this.bookingCount$.next(changes.createBookingList.currentValue.length);
      this.notificationService.updateFilteredBookingList(changes.createBookingList.currentValue);
    }

    if (changes.cabAllocBookingList && changes.cabAllocBookingList.currentValue) {
      this.cabAllocCount$.next(changes.cabAllocBookingList.currentValue.length);
      this.notificationService.updateFilteredCabAllocList(changes.cabAllocBookingList.currentValue);

    }

    if (changes.vendorBookingList && changes.vendorBookingList.currentValue) {
      this.vendorAcceptanceCount$.next(changes.vendorBookingList.currentValue.length);
      this.notificationService.updateFilteredVendorList(changes.vendorBookingList.currentValue);
    }
    let count: number = 0;
    if(this.notificationConfig?.showVendorAssignmentNotification && this.createBookingList?.length){
      count += this.createBookingList.length;
    }
    if(this.notificationConfig?.showVendorAcceptanceNotification && this.vendorBookingList?.length){
      count += this.vendorBookingList.length;
    }
    if(this.notificationConfig?.showCabAllocationNotification && this.cabAllocBookingList?.length){
      count += this.cabAllocBookingList.length;
    }
    this.notificationCount = count;
    this.changeDetect.detectChanges();
  }

  getSafeUrl() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.smallLogoURL);
  }
  handleUserLogout() {
    this.loginService.logout().subscribe((response) => {
      const client = this.authService.client.client;
      this.notificationService.clearAllDateForNotification();
      this.authService.setloginInfoSubject(false);
      this.commonService.clearService();
      this.commonBookingService.clearService();
      this.permissionsGuardService.clearPagePermissions();
      this.authService.userLogout();
      sessionStorage.clear();
      this.router.navigate([ `${client}/login`]);
    });
  }

  navigateToBooking(bookings, category) {
    const navigationExtras: NavigationExtras = {
      state: {
        bookingsList: bookings,
      }
    };
    if (category === 'createBooking') {
      this.router.navigate(['bookings-filtered-view'], navigationExtras);
    } else if (category === 'vendorBooking') {
      this.router.navigate(['bookings-filtered-vendor-view'], navigationExtras);
    } else if (category === 'cabAllocation') {
      this.router.navigate(['bookings-filtered-cab-view'], navigationExtras);
    }
 }

 navigateToEts() {
  const buid = this.authService.user.buId;
  const buIdParts = buid.split("-");
  const url = "http://" + buIdParts[0] + ".moveinsync.com/" + buIdParts[1] + "/master.jsp";
  window.location.href = url;
}

  clickedBulk() {
    this.bulkToggle = true;
    this.createToggle = false;
    this.router.navigate(['bookings/bulk-create']);

  }

  clickedCreate() {

    this.bulkToggle = false;
    this.createToggle = true;
    this.createBookingService.savedDocuments.next([]);
    this.router.navigate(['bookings/create']);
    this.createBookingService.showCreateBookingButton.next(false);
    this.createBookingService.daysCount.next(1);
  }

  onPolicyAccept(){
    this.openPolicyPopup = false;
    this.authService.setPolicyCookie();
  }


}
